"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = exports.calculateColours = void 0;
var defaultConfig = exports.defaultConfig = {
  circle: {
    size: '32px'
  },
  text: {
    lineHeight: 'm1',
    width: {
      s: '100%'
    }
  },
  rect: {
    height: {
      s: '50px'
    },
    width: {
      s: '100%'
    }
  }
};
var calculateColours = exports.calculateColours = function calculateColours() {
  var baseGrey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'grey200';
  var allowedColorValues = {
    grey200: 200,
    grey300: 300,
    grey400: 400,
    grey500: 500,
    grey600: 600,
    grey700: 700,
    grey800: 800
  };
  var baseGreyValue = allowedColorValues[baseGrey];
  if (!baseGreyValue) {
    return {
      color: 'grey200',
      animationColor: 'grey300'
    };
  }
  return {
    color: baseGrey,
    animationColor: "grey".concat(baseGreyValue + 100)
  };
};